export default __webpack_public_path__ + "static/media/Autoliv MXAG Facility - anexo 1 descripción del proyecto-Premios Impulso SUME.3734a677.pdf";